import { render, staticRenderFns } from "./PromotionalTagEdit.vue?vue&type=template&id=025bc212&"
import script from "./PromotionalTagEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionalTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports